import { createSlice } from '@reduxjs/toolkit'
import { fetchAllOperatorsReport, fetchAllPeriodicReport, fetchTopProfitReports } from 'redux-thunk/thunk/reports/operatorReports.thunk'

const initialState = {
  allOperatorReport: null,
  allOperatorPeriodicReport: null,
  topProfitReports: null,
  allClientPeriodicReport: null,
  allPeriodicReport: null
}

const operatorsReportSlice = createSlice({
  name: 'operatorsReportSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllOperatorsReport.fulfilled, (state, action) => {
        return {
          ...state,
          allOperatorReport: action.payload
        }
      })
      .addCase(fetchTopProfitReports.fulfilled, (state, action) => {
        return {
          ...state,
          topProfitReports: action.payload
        }
      })
      .addCase(fetchAllPeriodicReport.fulfilled, (state, action) => {
        return {
          ...state,
          allPeriodicReport: action.payload
        }
      })
  }
})

export default operatorsReportSlice.reducer
